import React from "react";
import { Routes, Route } from "react-router-dom";

import AuthLayout from "./components/layout/AuthLayout";
import DashboardLayout from "./components/layout/DashboardLayout";
import PrivateRoute from "./components/utils/PrivateRoute";
import Redirect from "./components/utils/Redirect";

import AuthApp2Fa from "./pages/auth/AuthApp2Fa";
import AuthOnboarding from "./pages/auth/AuthOnboarding";
import AuthSelect from "./pages/auth/AuthSelect";
import BusinessProfile from "./pages/auth/BusinessProfile";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import ResetPassword from "./pages/auth/ResetPassword";
import SignUp from "./pages/auth/SignUp";
import TwoFA from "./pages/auth/TwoFA";
import VerifyMail from "./pages/auth/VerifyMail";

import NotFound from "./pages/NotFound";

import Activity from "./pages/activity/Activity";
import Dashboard from "./pages/dashboard/Dashboard";
import Payment from "./pages/payment/Payment";
import PaymentPageDetail from "./pages/payment/PaymentPageDetail";
import Sales from "./pages/Sales";
import Settings from "./pages/settings/Settings";

import CustomerPayment from "./pages/custimerPayments/CustomerPayment";
import DepsitPage from "./pages/custimerPayments/DepsitPage";
import SinglePayment from "./pages/custimerPayments/SinglePayment";

const App = () => {
  return (
    <Routes>
      {/*
        Unauthenticated shell. AuthLayout owns the brand panel and the mobile
        logo, so these pages render their form only.
      */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/auth-onboarding" element={<AuthOnboarding />} />
        <Route path="/auth-select" element={<AuthSelect />} />
        <Route path="/2fa-auth" element={<TwoFA />} />
        <Route path="/2fa-auth-app" element={<AuthApp2Fa />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Post-signup steps: same shell, but require a session. */}
        <Route
          path="/verify-mail"
          element={
            <PrivateRoute>
              <VerifyMail />
            </PrivateRoute>
          }
        />
        <Route
          path="/business"
          element={
            <PrivateRoute>
              <BusinessProfile />
            </PrivateRoute>
          }
        />
      </Route>

      {/*
        Authenticated app shell. DashboardLayout owns the sidebar + navbar, so
        these pages must render their content only.
      */}
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/activity" element={<Activity />} />
        {/*
          Settings is URL-driven so tabs are deep-linkable and survive a
          refresh. Bare /settings is the mobile drill-down root; on wide
          screens the shell redirects it to the first tab.
        */}
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/:tab" element={<Settings />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment/:reference" element={<PaymentPageDetail />} />
        <Route path="/sales" element={<Sales />} />
      </Route>

      {/* Public customer-facing payment pages — no app chrome. */}
      <Route path="/business-page/:id" element={<CustomerPayment />} />
      <Route path="/payment-page/:id" element={<SinglePayment />} />
      <Route path="/payment-page/:id/deposit" element={<DepsitPage />} />

      <Route path="/" element={<Redirect to="/auth-onboarding" />} />

      {/* Catch-all. Previously an unknown URL matched nothing and rendered a
          blank page. */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
